import * as React from 'react';
import styled from '@emotion/styled';
import { TextInputWidget, TextInputWidgetProps } from './TextInputWidget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';

export interface SearchInputWidgetProps extends TextInputWidgetProps {
  className?: any;
  loading?: boolean;
}

export const SearchInputWidget: React.FC<SearchInputWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      <S.Icon icon={faSearch} />
      <S.Input placeholder={props.placeholder} value={props.value} onChange={props.onChange} submit={props.submit} />
      {props.loading ? (
        <S.LoadingWrapper>
          <S.Loading icon={faSpinner} spin={true} />
        </S.LoadingWrapper>
      ) : null}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
  `;

  export const Input = styled(TextInputWidget)`
    padding-left: 40px;
    padding-right: 40px;
    width: 100%;
    box-sizing: border-box;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: ${(p) => p.theme.text.primary};
  `;

  export const LoadingWrapper = styled.div`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  `;

  export const Loading = styled(FontAwesomeIcon)`
    color: ${(p) => p.theme.text.primary};
  `;
}
